import {
  Injectable,
  Component,
  Type,
  Injector,
  ViewContainerRef
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({ providedIn: 'root' })
export class LayoutService {

  public footerComponent$: BehaviorSubject<ComponentType<any> | null> = new BehaviorSubject(null);
  public footerComponentInjector: Injector | null;

  public setFooterComponent(component: ComponentType<any>, injector: Injector | null = null): void {
    this.footerComponent$.next(component);
    this.footerComponentInjector = injector;
  }

  public clearFooterComponent(): void {
    this.footerComponent$.next(null);
    this.footerComponentInjector = null;
  }

}
